//change from admin route
import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
import Datepicker from 'vuejs-datepicker';

import AdminService from '@/core/services/admin.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    Datepicker,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateAdminsComponent extends Vue {

  adminService: any = new AdminService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  roleList: any = [];
  companyList: any = [];
  name: string = "";
  surname: string = "";
  birthdate: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  companies: string = "defaultCompany";
  permissions: number = 3;
  manuallyPassword: boolean = false;
  autoGeneratedPassword: any = Math.random().toString(36).slice(-8);
  maxDate: any = new Date();

  mounted (){
    const _ = this;
    _.getRoles();
    _.getCompanies();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  get reporterRoles() {
    return this.roleList.filter((role: any) => role.type === "reporter");
  }

  getRoles(){
    const _ = this;
    _.isLoading = true;
    _.adminService.getRoles().then((data: any) => {
      _.roleList = data['data'].roles;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)

    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      _.isLoading = false;
    })
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.adminService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      _.companyList.sort(function(a, b) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  create(){
    const _ = this;
    let admin = {
      name: _.name,
      surname: _.surname,
      email: _.email,
      birthdate: _.birthdate,
      password: _.manuallyPassword ? _.password : _.autoGeneratedPassword,
      confirm_password: _.confirm_password,
      companyId: _.companies,
      roleId: _.permissions
    };
    console.log(admin);
    _.isLoading = true;
    _.adminService.create(admin).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/reporters');
      }, 2000)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  assingRol(user_id, role_id){
    const _ = this;
    console.log(user_id, role_id);
    _.adminService.assingRol(user_id, role_id).then((data: any) => {
    })
  }

  assingCompanies(user_id, company_id){
    const _ = this;
    console.log(user_id, company_id);
    _.adminService.assingCompanies(user_id, company_id).then((data: any) => {
    })
  }

  modifyIsAdmin(){

  }

  validations(email = '', password = '', confirm_password = ''){
    const _ = this;
    _.genericErr = [];
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!emailRegex.test(email.toLowerCase()) && email != ''){
      _.genericErr.push("Correo invalido");
    }
    if(email == ''){
      _.genericErr.push("Por favor escribe un correo");
    }
    if(password == '' && _.manuallyPassword){
      _.genericErr.push("Por favor escribe una contraseña");
    }
    if(password.length < 6 && password != '' && _.manuallyPassword){
      _.genericErr.push("La constraseña debe tener minimo 6 caracteres");
    }
    if(password != confirm_password && _.manuallyPassword){
      _.genericErr.push("Las constraseñas no coinciden");

    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
